import {createFeatureSelector, createSelector, MemoizedSelector} from '@ngrx/store';
import {DATASET_CONDITIONAL_DIMENSIONS_STATE_NAME, DataSetConditionalDimensionsState} from './dataSetConditionalDimensions';
import {Serializers} from '../../interfaces/serializer';
import {DataSetConditionalDimension} from '../../interfaces/dimensions';
import {DatasetConditionalDimensionComponentObjects} from '../../classes/dataset-conditional-dimension-component-object';

export const selectDataSetConditionalDimensionsState: MemoizedSelector<object, DataSetConditionalDimensionsState> = createFeatureSelector(DATASET_CONDITIONAL_DIMENSIONS_STATE_NAME);

export const selectDataSetConditionalDimensions: MemoizedSelector<object, Serializers<DataSetConditionalDimension>> = createSelector(
  selectDataSetConditionalDimensionsState,
  (state: DataSetConditionalDimensionsState): Serializers<DataSetConditionalDimension> => state.serialized
);

export const selectDataSetConditionalDimensionComponentObjects: MemoizedSelector<object, DatasetConditionalDimensionComponentObjects> = createSelector(
  selectDataSetConditionalDimensionsState,
  (state: DataSetConditionalDimensionsState): DatasetConditionalDimensionComponentObjects => state.componentObjects
);

export const selectDataSetConditionalDimensionsLoading: MemoizedSelector<object, boolean> = createSelector(
  selectDataSetConditionalDimensionsState,
  (state: DataSetConditionalDimensionsState): boolean => state.loading
);

export const selectDataSetConditionalDimensionsLoaded: MemoizedSelector<object, boolean> = createSelector(
  selectDataSetConditionalDimensionsState,
  (state: DataSetConditionalDimensionsState): boolean => state.loaded
);

export const selectDataSetConditionalDimensionsInitialized: MemoizedSelector<object, boolean> = createSelector(
  selectDataSetConditionalDimensionsState,
  (state: DataSetConditionalDimensionsState): boolean => state.initialized
);
